<template>
  <main-content-layout :title="$gettext('COURT_SETTLEMENTS')">
    <div class="p-5">
      <jt-data-table
        :api-mode="false"
        :data="dataFilter"
        :fields="columns"
        :is-paginated="false"
        noneselect
        @action-button="actionButton"
        :class="!dataFilter.length && 'tw-mt-6'"
      >
        <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-td>
            <q-td>
              {{ $gettext("MORE") }}
            </q-td>
          </q-tr>
        </template>
        <template #body="{ props }">
          <q-tr class="text-left">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              <div v-if="col.field == 'ref'">
                <strong style="font-size: 14px">
                  {{ props.row["mes"] }}
                </strong>
                <br />
                <span>
                  {{ props.row["ano"] }}
                </span>
              </div>
              <span v-else-if="col.field == 'situacao'">
                <situation :name="col.value" />
              </span>
              <span v-else-if="col.field == 'valor'" class="cell-values">
                <span style="font-size: 17px">
                  {{ $toLocaleStringBr(col.value) }}
                </span>
                <span style="font-size: 12px">
                  {{ $gettext("MATURITY") }}
                  {{
                    moment(
                      props.row["dtvencto_original"]
                        ? props.row["dtvencto_original"]
                        : props.row["dtvencto"]
                    ).format("DD/MM/YYYY")
                  }}
                </span>
              </span>
              <span v-else-if="col.field == 'vlpag'">
                <span style="font-size: 17px">
                  {{ $toLocaleStringBr(col.value) }}
                </span>
              </span>
              <span v-else-if="col.field == 'tipocob'">
                <span v-if="col.value" style="font-size: 13px"> Boleto </span>
                <span v-else style="font-size: 13px"> Convênio Samae </span>
              </span>

              <span v-else-if="col.field == 'dtpagto'" class="cell-values">
                <span v-if="props.row['vlpag']" style="font-size: 17px">
                  {{ $toLocaleStringBr(props.row["vlpag"]) }}
                </span>
                <span style="font-size: 12px">
                  {{ col.value && moment(col.value).format("DD/MM/YYYY") }}
                </span>
              </span>
              <span v-else-if="col.field == 'status'">
                <q-icon
                  v-if="col.value == 'J'"
                  name="gavel"
                  size="27px"
                  style="color: #8fe7d4"
                />
                <q-icon
                  v-else-if="Number(col.value) > 0"
                  name="mdi-account-details"
                  size="27px"
                  style="color: #e87d7d"
                />
                <q-icon
                  v-else
                  name="mdi-cash-usd"
                  size="27px"
                  style="color: #717171"
                />
              </span>

              <span v-else>
                {{ col.value }}
              </span>
            </q-td>

            <q-td style="width: 1px">
              <q-btn
                flat
                round
                color="primary"
                class="q-mr-sm"
                :icon="
                  props.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                "
                @click="props.expand = !props.expand"
              />
            </q-td>
          </q-tr>
          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <div class="row hidden-row">
                <div
                  v-for="(col, index) in props.cols"
                  :key="index"
                  style="padding: 5px 8px"
                  :class="index % 2 != 0 ? 'col-4' : 'col-4 row-paint-colapse'"
                >
                  <strong
                    ><label>{{ col.label }}:</label></strong
                  >
                  {{
                    col.field == "valor" || col.field == "vlpag"
                      ? $toLocaleStringBr(props.row[col.field])
                      : props.row[col.field]
                  }}
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
    </div>
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestInvoiceController from '../invoice/ServiceRequestInvoiceController'
import ServiceRequestController from '../../../ServiceRequestController'
import { QBtn } from 'quasar'
import moment from 'moment'
import Situation from '../invoice/component/InvoiceSituation.vue'
import MainContentLayout from '../../Layout/MainContentLayout.vue'

@Component({
  name: 'LegalSettlements',
  components: {
    MainContentLayout,
    QBtn,
    Situation
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class LegalSettlements extends Vue {
  data = [];
  moment = moment;
  controller = ServiceRequestController.getInstance();
  invoiceController = ServiceRequestInvoiceController.getInstance();
  columns = [
    {
      name: 'ref',
      label: 'REF',
      align: 'center',
      value: 'ref',
      field: 'ref'
    },
    {
      name: 'valor',
      align: 'center',
      label: 'Valor/ Vencimento',
      value: 'valor',
      field: 'valor'
    },
    {
      name: 'vlpag',
      align: 'center',
      label: 'Valor Atualizado',
      value: 'vlpag',
      field: 'vlpag'
    },
    {
      name: 'situacao',
      align: 'center',
      label: 'Situação',
      value: 'situacao',
      field: 'situacao'
    },
    {
      name: 'dtpagto',
      align: 'center',
      label: 'Data de pagamento',
      value: 'dtpagto',
      field: 'dtpagto'
    },
    {
      name: 'status',
      align: 'center',
      label: 'Status',
      value: 'status',
      field: 'status'
    },
    {
      name: 'tipocob',
      align: 'center',
      label: 'Forma de Pagamento',
      value: 'tipocob',
      field: 'tipocob'
    }
  ];

  get dataFilter () {
    return this.data.filter((row) => row.status == 'J')
  }

  async mounted () {
    this.data = await this.invoiceController.sigreInvoicesByUnid()
    this.data = this.data.map((row) => {
      return { ...row, selected: false }
    })
  }

  getTotalInformation (situation) {
    const filter = this.filterData(situation)
    const sum = this.sumValues(filter)
    const value = this.$toLocaleStringBr(sum)
    return {
      value: value || 'R$0,00',
      length: filter.length
    }
  }

  sumValues (arr) {
    return arr.reduce(
      (accumulator, row) =>
        accumulator + Number(row.vlpag ? row.vlpag : row.valor),
      0
    )
  }

  filterData (situation) {
    return this.data.filter((row) => row.situacao == situation)
  }

  get owner () {
    return this.controller.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ].owner
  }

  get occupier () {
    return this.controller.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ].occupier
  }

  get ownerDoc () {
    return this.controller.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ].infoCad.documentOwner.value
  }

  get occupierDoc () {
    return this.controller.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ].infoCad.documentOccupier.value
  }

  get paidOff () {
    return this.getTotalInformation('Quitado')
  }

  get pending () {
    return this.getTotalInformation('Em Aberto')
  }

  get inDelay () {
    return this.getTotalInformation('Vencida')
  }

  get selectedInformation () {
    const filter = this.data?.filter((v) => v.selected)
    const sum = this.sumValues(filter)
    const value = this.$toLocaleStringBr(sum)
    return {
      value: value || 'R$0,00',
      length: filter.length
    }
  }

  get negotiated () {
    return this.getTotalInformation('Negociada')
  }

  get isDebtAnotherOwner () {
    return 10 > 1
  }
}
export default LegalSettlements
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
</style>
